<template>
    <div>
        <h5 class="mb-3">
            <img
                src="/images/premium-icon.svg"
                alt="Prmium Icon"
                width="16px"
                v-if="template.template_type === 'premium'"
            />
            {{
                template.template_type === "premium"
                    ? "Premium Download"
                    : "Download For Free"
            }}
        </h5>
        <a-button
            type="primary"
            size="large"
            block
            class="mb-3"
            style="
                background: #dc4c4c !important;
                border: 1px solid #dc4c4c !important;
            "
            :disabled="!Boolean(canDownloadTemplate) || downloadingPowerpoint"
            :loading="downloadingPowerpoint"
            @click.prevent="downloadPowerpoint"
        >
            PowerPoint
        </a-button>
        <a-button
            type="primary"
            size="large"
            block
            :disabled="!Boolean(canDownloadTemplate) || copyingGoogleSlide"
            style="
                background: #ff9900 !important;
                border: 1px solid #ff9900 !important;
            "
            @click.prevent="copyGoogleSlide"
            v-if="template.google_slide_link"
            class="mb-3"
        >
            Google Slides
        </a-button>
        <a-button
            type="primary"
            size="large"
            block
            :disabled="!Boolean(canDownloadTemplate) || copyingGoogleSlide"
            style="
                background: #8b3dff !important;
                border: 1px solid #8b3dff !important;
            "
            @click.prevent="copyCanvaDesign"
            v-if="template.canva_link"
        >
            Canva
        </a-button>

        <p
            style="font-size: 13px"
            class="mt-4 text-center"
            v-if="Boolean(isLoggedIn) && !canDownloadTemplate"
        >
            <a href="/plans-pricing">Upgrade to a Premium Plan</a>
        </p>

        <div class="mt-3 mb-1" v-if="!Boolean(isLoggedIn)">
            <login-form />
        </div>
    </div>
</template>

<script>
import { HTTP } from "../api";
import LoginForm from "./login-form.vue";

export default {
    components: {
        LoginForm,
    },
    props: ["template", "canDownloadTemplate", "isLoggedIn"],
    data() {
        return {
            downloadingPowerpoint: false,
            copyingGoogleSlide: false,
            copyingCanvaDesign: false,
        };
    },
    methods: {
        async downloadPowerpoint() {
            if (Boolean(this.isLoggedIn)) {
                if (this.template.template_file) {
                    this.downloadingPowerpoint = true;
                    window.location.href = `/templates/${this.template.slug}/download`;
                    this.downloadingPowerpoint = false;
                } else {
                    this.$notification.error({
                        message: "Template download failed",
                        description:
                            "This template doesnot have any file to download.",
                    });
                }
            }
        },
        async copyGoogleSlide() {
            if (Boolean(this.isLoggedIn)) {
                if (this.template.google_slide_link) {
                    this.copyingGoogleSlide = true;
                    try {
                        const { data } = await HTTP.get(
                            `templates/${this.template.slug}/google-slide`
                        );
                        if (data && data?.url && data?.url !== "") {
                            window.open(data?.url, "_blank");
                        }
                    } catch (error) {
                        if (error.response && error.response.status === 401) {
                            window.location.reload();
                        }
                    }
                    this.copyingGoogleSlide = false;
                } else {
                    this.$notification.error({
                        message: "Google slide download failed",
                        description:
                            "This template does not have any url to copy/download using google slide.",
                    });
                }
            }
        },
        async copyCanvaDesign() {
            if (Boolean(this.isLoggedIn)) {
                if (this.template.canva_link) {
                    this.copyingCanvaDesign = true;
                    try {
                        const { data } = await HTTP.get(
                            `templates/${this.template.slug}/canva-design`
                        );
                        if (data && data?.url && data?.url !== "") {
                            window.open(data?.url, "_blank");
                        }
                    } catch (error) {
                        if (error.response && error.response.status === 401) {
                            window.location.reload();
                        }
                    }
                    this.copyingCanvaDesign = false;
                } else {
                    this.$notification.error({
                        message: "Canva design download failed",
                        description:
                            "This template does not have any url to copy/download using canva design.",
                    });
                }
            }
        },
    },
};
</script>
